





































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
// Constants
import {
  CreateButtons,
  RelatedDatastoreNames,
  MatterInfomationRegisterData,
  MaterialListTabItems,
  MatterTabItems,
  MasterSelectDataColumns,
  MasterSelectDataBodies,
  PaymentTypeItem,
  SearchItems,
  authorityValidMessage,
  authorityInvalidMessage,
  registerFinishText
} from '@/constants/matter/matter';
import {
  ActionFieldSeeting,
  FieldChildrenProp,
  GetInputFieldsActons
} from '@/services/hexabase/types';
import { SelectItemProps, TabItemProps } from '@/constants/matter/types';
import { DSNames } from '@/constants/dataStore';
// Models
import Matter from '@/models/matterModel';
import Customer from '@/models/customerModel';
// Components
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';
import MasterSelectSetControl from '@/components/common/modules/MasterSelectSetControl.vue';
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import TabPanel from '@/components/common/modules/TabPanel.vue';
import StatusBox from '@/components/common/modules/StatusBox.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import {
  matterRegisterOptionalForm,
  matterOptionalChangeForm
} from '@/constants/form/matterForm';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    TransitionDialog,
    ExecAction,
    TabPanel,
    InputNoVModel,
    SelectNoVModel,
    MasterSelectSetControl,
    MasterSelectMultiSetControl,
    StatusBox,
    AutoCreateForm
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class MatterRegister extends Vue {
  private matter = new Matter();
  private customer = new Customer();

  private registAuthority = false;

  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';

  private prevRoute: any = null;
  private urlParams: any = {};
  private projectId = hexabaseState.applicationId;
  private displayStatus = '';

  private screenStructureType: any = null;
  private serviceType: any = null;
  // TabPanel's property
  private materialListTabItems: Array<TabItemProps> = [];
  private matterTabItems: Array<TabItemProps> = [];
  // Master
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  private masterSelectDataColumn: any = [];
  private masterSelectData: any = [];
  private masterSelectDataColumns = JSON.parse(JSON.stringify(MasterSelectDataColumns));
  private masterSelectDataBodies = JSON.parse(JSON.stringify(MasterSelectDataBodies));
  private paymentInformationLists: any = {};
  // Datasotre
  private matterFields!: GetInputFieldsActons;
  private relatedFields: { [key: string]: GetInputFieldsActons } = {};
  // DatastoreFieldSetting
  private matterFieldsSetting: { [k: string]: any } = {};
  private tabItemsFieldsSetting: { [k: string]: any } = {};
  // Dropdown's properties
  private leasingCompanyColumns: any = [];
  private leasingCompanyDatas: any = [];
  private customerDepartmentPaymentInfomationItem: SelectItemProps = JSON.parse(
    JSON.stringify(PaymentTypeItem)
  );
  private paymentInfomationItem: SelectItemProps = JSON.parse(JSON.stringify(PaymentTypeItem));
  // MasterSelect's properties
  private searchItems = SearchItems;
  private masterSelectCustomerData: any = [];
  private masterSelectCustomerDepartmentData: any = [];
  private masterSelectServiceTypeData: any = [];
  private masterSelectCustomerSelected: any = null;
  private masterSelectCustomerDepartmentSelected: any = null;
  private masterSelectServiceTypeSelected: any = null;

  // アイテム登録後ダイアログ
  private guideMessage = '';
  private dialogStatus = false;
  private isLoading = false;
  private registerText = this.matter.deepCopy(registerFinishText);
  private buttons: any = JSON.parse(JSON.stringify(CreateButtons));

  // Data stock
  private matterInfomationRegisterData: any = JSON.parse(
    JSON.stringify(MatterInfomationRegisterData)
  );

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some((obj) => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  // dbID格納プロパティ
  private mainDsId = '';
  private customerDsId = '';

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.mainDsId = hexabaseState.datastoreIds['案件基本情報'];
      this.customerDsId = hexabaseState.datastoreIds['顧客マスタ'];

      // Get data from master
      await this.getMasterData();
      // Get datas from application
      await this.getApplicationData();
      // Set DefaultValue
      this.setDefaultValues();
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    switch (type) {
      case 'register':
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);

          // 売上予定月・工事完了予定日から売上見込日の設定と工事完了日の判定
          this.matter.setExpectedSalesDate(this.matterInfomationRegisterData);

          // 基本データの成形
          const item: any = {};
          let customerId = '';
          Object.keys(this.matterInfomationRegisterData).forEach((displayId: string) => {
            if (this.matterInfomationRegisterData[displayId] !== '') {
              if (displayId !== 'relatedItems') {
                if (displayId === 'customer_id') {
                  customerId = this.matterInfomationRegisterData[displayId];
                }
                item[displayId] = this.matterInfomationRegisterData[displayId];
              }
            }
          });
          // 担当者を設定
          item.manager_id = userState.getUserEmployeeId;
          // 会社名を設定
          const companyItem = this.findCompanyItem(item.manager_id);
          item.company_id = companyItem ? companyItem.i_id : '';
          // 案件番号を発番
          const autoNumber = await this.matter.getAutoNumber(
            this.projectId,
            this.mainDsId,
            'id',
            userState.getMatterBranchKey
              ? {
                  branch_key: userState.getMatterBranchKey,
                  zero_padding: 'true',
                  digit: '5'
                }
              : {}
          );
          // 案件番号を設定
          item.project_id = autoNumber.result.value;
          this.matterInfomationRegisterData.relatedItems.projectServiceOA['project_id'] =
            autoNumber.result.value;
          this.matterInfomationRegisterData.relatedItems.projectServiceGeneral['project_id'] =
            autoNumber.result.value;
          this.matterInfomationRegisterData.relatedItems.projectServiceFJapan['project_id'] =
            autoNumber.result.value;

          // 関連データの成形
          const relatedItems: { [key: string]: Array<any> } = {};
          const relatedItemDatas: any = this.matterInfomationRegisterData['relatedItems'];

          Object.keys(relatedItemDatas).forEach((dsName: string) => {
            const dsId = hexabaseState.datastoreIds[RelatedDatastoreNames[dsName]];
            const fields = this.relatedFields[dsName];
            const itemDatas = relatedItemDatas[dsName];

            const item: any = {};
            const relatedChildItems: any = {};

            Object.keys(itemDatas).forEach((displayId) => {
              const itemData = itemDatas[displayId];
              if (Array.isArray(itemData)) {
                const childDsId = hexabaseState.datastoreIds[RelatedDatastoreNames[displayId]];
                const fields = this.relatedFields[displayId];

                Object.values(itemData).forEach((values: any) => {
                  const childItem: any = {};
                  Object.keys(values).forEach((displayId: any) => {
                    childItem[displayId] = values[displayId];
                  });
                  if (Object.keys(childItem).length > 0) {
                    if (relatedChildItems[childDsId] === undefined) {
                      relatedChildItems[childDsId] = [];
                    }
                    relatedChildItems[childDsId].push({
                      link_to_parent: true,
                      operation: 1,
                      item: childItem
                    });
                  }
                });
              } else {
                item[displayId] = itemData;
              }
            });

            if (Object.keys(item).length > 0 || Object.keys(relatedChildItems).length > 0) {
              const relatedItem: any = {
                operation: 1,
                link_to_parent: true
              };
              if (relatedItems[dsId] === undefined) {
                relatedItems[dsId] = [];
              }
              if (Object.keys(item).length > 0) {
                relatedItem.item = item;
              }
              if (Object.keys(relatedChildItems).length > 0) {
                relatedItem.related_ds_items = relatedChildItems;
              }
              relatedItems[dsId].push(relatedItem);
            }
          });

          // 顧客との関連づけ
          relatedItems[this.customerDsId] = [
            {
              operation: 11,
              link_to_parent: true,
              i_id: customerId
            }
          ];

          // サービス種別に応じた不必要なrelatedItemsデータを除外
          if (this.screenStructureType == 1) {
            // サービス種別がOAの場合、OA以外のrelatedItemsを削除
            delete relatedItems[hexabaseState.datastoreIds['案件サービス別汎用']];

            Object.keys(DSNames).forEach((screenStructureType: string) => {
              if (this.screenStructureType != screenStructureType) {
                if ('PROJECT_SERVICE' in DSNames[screenStructureType]) {
                  delete relatedItems[hexabaseState.datastoreIds[DSNames[screenStructureType].PROJECT_SERVICE]];
                }
              }
            });
          } else if (this.screenStructureType == 2) {
            // サービス種別がF-Japanの場合、F-Japan以外のrelatedItemsを削除
            delete relatedItems[hexabaseState.datastoreIds['案件サービス別OA']];
            delete relatedItems[hexabaseState.datastoreIds['案件サービス別汎用']];
          } else {
            // サービス種別が汎用の場合、汎用以外のrelatedItemsを削除
            delete relatedItems[hexabaseState.datastoreIds['案件サービス別OA']];
            Object.keys(DSNames).forEach((screenStructureType: string) => {
              if (this.screenStructureType != screenStructureType) {
                if ('PROJECT_SERVICE' in DSNames[screenStructureType]) {
                  delete relatedItems[hexabaseState.datastoreIds[DSNames[screenStructureType].PROJECT_SERVICE]];
                }
              }
            });
          }

          // 登録時のアクションを設定
          const actionId: any = (() => {
            switch (this.screenStructureType) {
              case '1':
                return 'insert';
              case '99':
                return 'insert';
              case '2':
                return 'insert';
              default:
            }
          })();

          // 登録リクエスト
          const params: any = {
            action_id: actionId,
            item: item,
            return_item_result: true,
            ensure_transaction: true,
            related_ds_items: relatedItems
          };

          const result = await this.matter.registerLinkedItems(
            this.projectId,
            this.mainDsId,
            params
          );
          this.matter.apiErrorHandle('CREATEITEM', result);
          this.registerText = this.matter.deepCopy(registerFinishText);
          this.buttons.splice(0);
          this.buttons = JSON.parse(JSON.stringify(CreateButtons));
          const resultId = result.item_id;
          // 画面遷移情報のセット
          this.buttons[0].route = this.buttons[0].route.replace(':id', resultId);
        } catch (e) {
          console.log(e);
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          this.dialogStatus = true;
        }
        break;
      case 'cancel':
        this.backPreviousPage();
        break;
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  modifyFields(
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    inputFields: GetInputFieldsActons,
    type: string
  ) {
    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update && !field.props!.isDisabled) {
          field.props! = {
            ...field.props!,
            ...{ isDisabled: false, isReadonly: false }
          };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperation
   * @param data - 名前と入力値
   * @param index - 複数行項目変更時の行番号
   */
  async inputOperation(data: any, index?: number) {
    if (index === undefined && data.name.indexOf('.') === -1) {
      if (data.name === 'customer_id') {
        // 顧客
        this.masterSelectCustomerSelected = { i_id: data.value };
        const item = this.masterData.m_customer.body.find((v: any) => v.i_id === data.value);
        this.$set(this.matterInfomationRegisterData, 'telephone_number', item!['telephone_number']);
      }
      if (data.name === 'department_billing_address_id') {
        // 顧客部署（申込元・請求先）
        const index = this.masterSelectCustomerDepartmentData.findIndex(
          (item: any) => item.i_id === data.value
        );
        const str = this.masterSelectCustomerDepartmentData[index].payment_infomation;
        const selectedIndex = this.customerDepartmentPaymentInfomationItem.options.findIndex(
          (item: any) => item.text === str
        );
        this.$set(
          this.matterInfomationRegisterData,
          'billing_payment_information',
          this.customerDepartmentPaymentInfomationItem.options[selectedIndex].value
        );
        this.basicFieldsData.find(v => v.display_id === 'billing_payment_information')![
          'props'
        ]!.value = this.customerDepartmentPaymentInfomationItem.options[selectedIndex].value;
      }
      if (data.name === 'department_delivery_destination_id') {
        // 顧客部署（設置先・納入先）
        const index = this.masterSelectCustomerDepartmentData.findIndex(
          (item: any) => item.i_id === data.value
        );
        const customerDepartment = this.masterSelectCustomerDepartmentData[index];
        let str = customerDepartment.prefectures ? String(customerDepartment.prefectures) : '';
        str += customerDepartment.municipalities ? String(customerDepartment.municipalities) : '';
        str += customerDepartment.machimura_street_address
          ? String(customerDepartment.machimura_street_address)
          : '';
        str += customerDepartment.building_name ? String(customerDepartment.building_name) : '';
        this.$set(this.matterInfomationRegisterData, 'installation_address', str);
        this.basicFieldsData.find(v => v.display_id === 'installation_address')![
          'props'
        ]!.value = str;
      }
      if (data.name === 'service_type_id') {
        // サービス種別
        const item = this.masterSelectServiceTypeData.find((v: any) => v.i_id === data.value);
        this.masterSelectServiceTypeSelected = item;
        const screenStructureType = item!['screen_structure_type'];
        const serviceType = item!['service_type'];
        this.screenStructureType = screenStructureType;
        this.serviceType = serviceType;
      }
      const index = this.basicFieldsData.findIndex(v => v.display_id === data.name);
      this.$set(this.matterInfomationRegisterData, data.name, data.value);
      this.$set(this.basicFieldsData[index].props!, 'value', data.value);
    } else {
      // タブパネル内コンテンツ
      const dataNames = data.name.split('.');
      if (dataNames.length == 2) {
        // 子
        const [targetTran, targetColumn] = Object.values(dataNames);
        let baseObj = this.matterInfomationRegisterData.relatedItems[targetTran];
        if (index !== undefined) {
          if (baseObj[index] === undefined) {
            baseObj[index] = {};
          }
          baseObj[index][targetColumn] = data.value;
        } else {
          if (baseObj === undefined) {
            baseObj = {};
          }
          baseObj[targetColumn] = data.value;
        }
      }
    }
    // TODO:20220906 FT様向けデモ用に非表示、サービス種別ごとに項目表示する為の検討が必要
    for (const index in this.basicFieldsData) {
      if ( this.basicFieldsData[index].display_id.indexOf('general_item_') != -1) {
        this.basicFieldsData[index].show = false;
      }
    }
  }

  private tabChildrenEventRelay(response: any) {
    switch (response.action) {
      case 'addRow': {
        // 登録画面では何もしない
        break;
      }
      default: {
        this.inputOperation(response.data, response.index);
        break;
      }
    }
  }

  private changeSelect(data: any) {
    switch (data.name) {
      case 'billing_payment_information':
        // 請求先支払情報
        this.customerDepartmentPaymentInfomationItem.selected = data.value.value;
        // 登録情報にも反映
        this.matterInfomationRegisterData[
          'billing_payment_information'
        ] = this.customerDepartmentPaymentInfomationItem.selected;
        break;
      case 'payment_information':
        // 支払情報
        this.paymentInfomationItem.selected = data.value.value;
        // 登録情報にも反映
        this.matterInfomationRegisterData[
          'payment_information'
        ] = this.paymentInfomationItem.selected;
        break;
      default:
        break;
    }
  }

  /**
   * 戻る処理
   */
  private backPreviousPage() {
    const beforeRoute = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };

    if (this.prevRoute) {
      const paths = this.prevRoute.fullPath.split('/');
      if (['list', 'searchlist'].includes(paths[paths.length - 1].toLowerCase())) {
        beforeRoute.query = { searchConditions: 'true' };
      }
    }

    this.$router.push(beforeRoute);
  }

  /**
   * マスタデータ取得
   */
  private async getMasterData() {
    // マスターデータを取得しグローバル変数に格納
    await this.matter.getRegisterMasterData();
    this.masterData = this.matter.getMaster();

    // 顧客
    for (const key in this.masterData['m_customer'].body) {
      this.masterSelectCustomerData.push(this.masterData['m_customer'].body[key]);
    }
    // 顧客部署
    for (const key in this.masterData['m_customer_department'].body) {
      // this.masterSelectCustomerDepartmentData.push(this.masterData['m_customer_department'].body[key]);
    }
    // サービス種別
    for (const key in this.masterData.m_service_type.body) {
      this.masterSelectServiceTypeData.push(this.masterData.m_service_type.body[key]);
    }
    // リース会社
    this.leasingCompanyColumns = this.masterData['m_leasing_company'].columns;
    for (const key in this.masterData['m_leasing_company'].body) {
      this.leasingCompanyDatas.push(this.masterData['m_leasing_company'].body[key]);
    }
    // 支払情報
    for (const key in this.masterData.m_payment_information.body) {
      const type = this.masterData.m_payment_information.body[key].service_type_id;
      if (this.paymentInformationLists[type] === undefined) {
        this.paymentInformationLists[type] = [];
      }
      this.paymentInformationLists[type].push({
        value: this.masterData.m_payment_information.body[key].i_id,
        text: this.masterData.m_payment_information.body[key].payment_information
      });
    }
  }

  /**
   * アプリケーション関連データ取得
   */
  private async getApplicationData() {
    // Get status list
    // Get new action-list(matter)
    const [statusList, actionList] = await Promise.all([
      this.matter.getStatusList(this.projectId, this.mainDsId).then(data => data[0].statuses),
      this.matter.getNewActionList(this.mainDsId)
    ]);
    this.displayStatus = statusList ? statusList[0].status_name : 'ステータス取得失敗';

    // 権限判定用アクションを取得
    const action = actionList.actions.find(
      (v) => v.display_id === 'project_basic_infomation_registe'
    );
    if (actionList.actions[0].action_id !== undefined) {
      // フィールド情報
      const [inputFields, fieldsData] = await Promise.all([
        this.matter.getFieldsByActionId(this.mainDsId, actionList.actions[0].action_id),
        this.matter.makeFieldsList(this.projectId, this.mainDsId)
      ]);
      this.matterFields = inputFields;
      const data = this.matter
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.matter.deepCopy(matterRegisterOptionalForm),
          true
        )
        .map((field) => this.matter.inputRestriction(field, inputFields))
        .map((field) => this.matter.addOptionalMasterData(field, this.masterData));
      // フォーカス調整のため要素を並べ替え
      const sortwk1 = data.sort(function(a, b) {
        return (a.col || 0) - (b.col || 0);
      });
      const sortwk2 = sortwk1.sort(function(a, b) {
        return (a.row || 0) - (b.row || 0);
      });
      this.basicFieldCols = this.customer.getGridStatus(sortwk2);
      this.basicFieldsData = this.modifyFields(sortwk2, inputFields, '');
      // 権限を判定
      this.registAuthority = action !== undefined ? true : false;
      this.guideMessage = this.registAuthority ? authorityValidMessage : authorityInvalidMessage;
      // 請求先支払情報
      const billingPaymentInformation = Object.values(this.matterFields.action_fields).find(
        (value) => {
          return value.display_id === 'billing_payment_information';
        }
      );
      const billingPaymentInformations = billingPaymentInformation.options
        .sort((a: any, b: any) => {
          return (a.sort_id < b.sort_id) ? -1 : 1;
        })
        .map((option: any) => {
          return { value: option.option_id, text: option.value };
        });
      this.$set(
        this.customerDepartmentPaymentInfomationItem,
        'options',
        billingPaymentInformations
      );
    }
    // Get new action-list(related-ds)
    await Promise.all(
      Object.entries(RelatedDatastoreNames).map(async (RelatedDatastoreNames) => {
        const storeName = RelatedDatastoreNames[1];
        const dsId = hexabaseState.datastoreIds[storeName];
        const actionList = await this.matter.getNewActionList(dsId);
        const action = actionList.actions.shift();
        if (action !== undefined) {
          const fields = await this.matter.getFieldsByActionId(dsId, action.action_id);
          this.relatedFields[RelatedDatastoreNames[0]] = fields;
          // フィールド設定を取得
          const tmpList: any = {};
          for (const [field_id, value] of Object.entries(fields.action_fields)) {
            const { mandatory, update, show } = fields.action_field_settings[field_id];
            const rules: string[] = [];
            if (mandatory) {
              rules.push('required');
            }
            tmpList[value.display_id] = {
              setting: { mandatory: mandatory, update: update, show: show },
              rules: rules.join('|')
            };
          }
          this.tabItemsFieldsSetting[storeName] = tmpList;
        }
      })
    );
  }

  /**
   * デフォルト値セット
   */
  private setDefaultValues() {
    // サービス種別
    const item = this.masterSelectServiceTypeData.find((v: any) => v.default_type === 'true');

    this.masterSelectServiceTypeSelected = item;
    this.basicFieldsData.find(v => v.display_id === 'service_type_id')!['props']!.value = item;
    this.serviceType = item.service_type;
    this.$set(this.matterInfomationRegisterData, 'service_type_id', item.i_id);
    this.screenStructureType = item.screen_structure_type;
  }

  /**
   * 初期値設定
   */
  private async getInitialValues() {
    if (Object.keys(this.$route.params).length > 0) {
      const customerItemId = this.$route.params.id;
      if (customerItemId) {
        // 顧客
        this.masterSelectCustomerSelected = { i_id: customerItemId };
        this.$set(this.matterInfomationRegisterData, 'customer_id', customerItemId);
        this.basicFieldsData.find(v => v.display_id === 'customer_id')![
          'props'
        ]!.value = customerItemId;
      }
    }
  }

  private async setCustomerInfo(customerItemId: string) {
    try {
      this.$store.commit('hexabase/setIsLoading', true);

      // Define variavles
      let customerDepartmentId: any = '';
      let paymentInformation: any = '';
      let installationAddress: any = '';
      // 顧客連絡先
      const [customer, customerDepartment] = await Promise.all([
        this.customer.getItemDetails(this.projectId, this.customerDsId, customerItemId),
        this.customer.getLinked(
          this.projectId,
          this.customerDsId,
          customerItemId,
          hexabaseState.datastoreIds['顧客部署マスタ']
        )
      ]);
      const telephoneNumber = customer.field_values.find(
        (field: any) => field.field_id === 'telephone_number'
      );
      this.$set(this.matterInfomationRegisterData, 'telephone_number', telephoneNumber.value);
      // 顧客部署
      if (customerDepartment.result.m_customer_department.items.length > 0) {
        const linkedCustomerDepartment: any = customerDepartment.result.m_customer_department;
        const idFieldId = Object.keys(linkedCustomerDepartment.fields).find((key: string) => {
          return linkedCustomerDepartment.fields[key].display_id === 'id';
        });
        if (idFieldId) {
          const sortedItems = linkedCustomerDepartment.items.sort((a: any, b: any) => {
            return a[idFieldId] > b[idFieldId] ? -1 : 1;
          });
          const customerDepartmentFields = await this.matter.getFieldsData(
            this.projectId,
            hexabaseState.datastoreIds['顧客部署マスタ']
          );
          const headOfficeJudgmentFlag = Object.values(customerDepartmentFields.fields).find(
            (field) => {
              return field.display_id === 'head_office_judgment_flag';
            }
          );

          if (headOfficeJudgmentFlag) {
            const index = sortedItems.findIndex(
              (item: any) => item[headOfficeJudgmentFlag.display_id] === '本社'
            );
            if (index > -1) {
              const customerDeparment = sortedItems[index];
              customerDepartmentId = customerDeparment.i_id;
              this.masterSelectCustomerDepartmentSelected = customerDeparment;
              // 自動生成部指定
              this.basicFieldsData.find(v => v.display_id === 'department_billing_address_id')![
                'props'
              ]!.value = customerDeparment;
              this.basicFieldsData.find(
                v => v.display_id === 'department_delivery_destination_id'
              )!['props']!.value = customerDeparment;
              // 請求先支払情報
              const paymentInfomationFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'payment_infomation';
                }
              );
              if (paymentInfomationFieldId) {
                const option = this.customerDepartmentPaymentInfomationItem.options.find(
                  (option: any) => {
                    return option.text === customerDeparment[paymentInfomationFieldId];
                  }
                );
                if (option) {
                  paymentInformation = option.value;
                }
              }
              // 設置先住所
              const prefecturesFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'prefectures';
                }
              );
              const municipalitiesFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'municipalities';
                }
              );
              const streetAddressFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return (
                    linkedCustomerDepartment.fields[key].display_id === 'machimura_street_address'
                  );
                }
              );
              const buildingNameFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'building_name';
                }
              );
              if (
                prefecturesFieldId &&
                municipalitiesFieldId &&
                streetAddressFieldId &&
                buildingNameFieldId
              ) {
                installationAddress = [
                  customerDeparment[prefecturesFieldId],
                  customerDeparment[municipalitiesFieldId],
                  customerDeparment[streetAddressFieldId],
                  customerDeparment[buildingNameFieldId]
                ].join('');
              }
            } else {
              this.masterSelectCustomerDepartmentSelected = '';
            }
          }
        }
      }

      this.$set(
        this.matterInfomationRegisterData,
        'department_billing_address_id',
        customerDepartmentId
      );
      this.$set(
        this.matterInfomationRegisterData,
        'department_delivery_destination_id',
        customerDepartmentId
      );
      this.$set(
        this.matterInfomationRegisterData,
        'billing_payment_information',
        paymentInformation
      );
      // 自動生成部指定
      this.basicFieldsData.find(v => v.display_id === 'billing_payment_information')![
        'props'
      ]!.value = paymentInformation;
      this.$set(this.matterInfomationRegisterData, 'installation_address', installationAddress);
      // 自動生成部指定
      this.basicFieldsData.find(v => v.display_id === 'installation_address')![
        'props'
      ]!.value = installationAddress;
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  @Watch('screenStructureType')
  private onChangeScreenStructureType() {
    if (this.screenStructureType !== null) {
      this.materialListTabItems.splice(0);
      this.matterTabItems.splice(0);

      const materialListTabItems = JSON.parse(JSON.stringify(MaterialListTabItems.Create[this.screenStructureType]));
      for (const [index, tabItem] of materialListTabItems.entries()) {
        this.$set(this.materialListTabItems, index, tabItem);
      }
      const tabItems = JSON.parse(JSON.stringify(MatterTabItems.Create[this.screenStructureType]));
      for (const [index, tabItem] of tabItems.entries()) {
        this.$set(this.matterTabItems, index, tabItem);
      }
      this.$set(
        this.matterInfomationRegisterData,
        'relatedItems',
        JSON.parse(JSON.stringify(MatterInfomationRegisterData.relatedItems))
      );
      this.getInitialValues();
    }
  }

  @Watch('serviceType')
  private onChangeServiceType() {
    if (this.serviceType) {
      const options = this.paymentInformationLists[this.serviceType];
      this.paymentInfomationItem.options = options;
      this.$set(
        this.matterInfomationRegisterData,
        'service_type_id',
        this.masterSelectServiceTypeSelected.i_id
      );
      this.$set(this.matterInfomationRegisterData, 'payment_information', options[0].value);
      this.basicFieldsData.find(v => v.display_id === 'payment_information')!['props']!.value =
        options[0].value;
      this.basicFieldsData.find(v => v.display_id === 'payment_information')![
        'props'
      ]!.selectData = this.paymentInfomationItem;

      // サービス種別を変更した際の項目名変更
      this.matter.changeFormLabel(matterOptionalChangeForm[this.serviceType], this.basicFieldsData);
    }
  }

  @Watch('masterSelectCustomerSelected')
  private onChangeCustomerSelected() {
    const baseList = Object.values(this.masterData['m_customer_department'].body).map(data => data);

    this.masterSelectCustomerDepartmentData.splice(0);
    const filteredItems = baseList.filter((customerDepartmentData: any) => {
      if (customerDepartmentData.item_links && customerDepartmentData.item_links.item_count > 0) {
        const linkItem = customerDepartmentData.item_links.links.find(
          (link: any) => link.d_id === this.customerDsId
        );
        if (linkItem && linkItem.items.length > 0) {
          return linkItem.items.some(
            (linkItem: any) => linkItem.i_id === this.masterSelectCustomerSelected.i_id
          );
        }
      }
    });
    filteredItems.map((customerDepartmentData: any) => {
      this.masterSelectCustomerDepartmentData.push(customerDepartmentData);
    });
    this.basicFieldsData.find(v => v.display_id === 'department_billing_address_id')![
      'props'
    ]!.body = this.masterSelectCustomerDepartmentData;
    this.basicFieldsData.find(v => v.display_id === 'department_delivery_destination_id')![
      'props'
    ]!.body = this.masterSelectCustomerDepartmentData;

    this.setCustomerInfo(this.masterSelectCustomerSelected.i_id);
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.matter.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 社員IDから社員マスタの情報を取得して、
   * 取得した社員マスタの情報と企業マスタのcompany_nameから
   * 社員の所属する企業マスタの情報を取得する
   * @module findCompanyItem
   * @param findId - 社員マスタの検索に使用するid
   * @param return - 企業マスタのアイテム
   */
  private findCompanyItem(findId: string) {
    const employeeItem = this.masterData['m_employee'].body.find((recode: any) => {
      if (recode.i_id === findId) {
        return recode;
      }
    });
    if (employeeItem !== undefined) {
      const companyItem = this.masterData['m_company'].body.find((recode: any) => {
        if (recode.company_name === employeeItem.company_id) {
          return recode;
        }
      });
      return companyItem;
    }
  }
}
